import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const mockGalleryPhotos = [
  {
    id: 1,
    title: '2024 Mezuniyet Töreni',
    image: 'https://fs.hacettepe.edu.tr/fenyeni/fotogaleri/2024%20mezuniyet/IMG_5656.JPG',
    link: '/albums/2024_mezuniyet_toreni-91',
  },
  {
    id: 2,
    title: 'Cumhuriyetimizin 100. Yılı Etkinliği',
    image: 'https://fs.hacettepe.edu.tr/fenyeni/fotogaleri/Sempozyum/DSC_0113-min.JPG',
    link: '/albums/cumhuriyetimizin_100_yili_etki-79',
  },
  {
    id: 3,
    title: 'Cumhuriyetin Harcında Bilim ve Kadınlar',
    image: 'https://fs.hacettepe.edu.tr/fenyeni/fotogaleri/Müsemma/IMG_5481.JPG',
    link: '/albums/cumhuriyetin_harcinda_bilim_ve-81',
  },
  {
    id: 4,
    title: '2023 Yılı Mezuniyet Töreni',
    image: 'https://fs.hacettepe.edu.tr/fenyeni/fotogaleri/2023%20Mezuniyet/DSC_6908.jpg',
    link: '/albums/2023_yili_mezuniyet_toreni-75',
  },
  {
    id: 5,
    title: 'Johnson&Johnson Klinik Araştırmalar Semineri',
    image: 'https://fs.hacettepe.edu.tr/fenyeni/fotogaleri/johnson/IMG_5579.JPG',
    link: '/albums/johnsonjohnson_klinik_arastirm-85',
  },
  {
    id: 6,
    title: 'Acıgöl dişli sazancığı, Beytepe Göleti',
    image: 'https://fs.hacettepe.edu.tr/fenyeni/fotogaleri/ac%C4%B1g%C3%B6l/IMG_5612.JPG',
    link: '/albums/acigol_disli_sazancigi_torenle-83',
  },
];

const PhotoCard = ({ photo, className }) => (
  <div className={`relative w-full h-full min-h-[200px] overflow-hidden rounded-2xl group ${className}`}>
    <img
      src={photo.image}
      alt={photo.title}
      loading="lazy"
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
    <div className="absolute bottom-0 left-0 p-6 text-white">
      <h3 className="text-xl font-bold">{photo.title}</h3>
    </div>
  </div>
);

const GalleryPreviewSection = () => {
  const { t } = useTranslation();

  return (
    <div className="relative mt-24 py-16 bg-white overflow-hidden">
      <div className="relative px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4 font-serif tracking-tight">
            {t('home.gallery.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('home.gallery.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-12 grid-rows-2 gap-4 h-[700px]">
          {/* Büyük Fotoğraf (Sol) */}
          <div className="col-span-12 md:col-span-7 row-span-2 h-full">
            <PhotoCard photo={mockGalleryPhotos[0]} className="w-full h-full" />
          </div>

          {/* Küçük Fotoğraf (Sağ Üst) */}
          <div className="col-span-12 md:col-span-5 row-span-1 h-full">
            <PhotoCard photo={mockGalleryPhotos[1]} className="w-full h-full" />
          </div>

          {/* Küçük Fotoğraf (Sağ Alt) */}
          <div className="col-span-12 md:col-span-5 row-span-1 h-full">
            <PhotoCard photo={mockGalleryPhotos[2]} className="w-full h-full" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          {/* Alt Sıra 1 */}
          <div className="h-full aspect-[4/3]">
            <PhotoCard photo={mockGalleryPhotos[3]} className="w-full h-full" />
          </div>

          {/* Alt Sıra 2 */}
          <div className="h-full aspect-[4/3]">
            <PhotoCard photo={mockGalleryPhotos[4]} className="w-full h-full" />
          </div>

          {/* Galeriye Git Kartı */}
          <div className="relative overflow-hidden rounded-2xl group aspect-[4/3] h-full bg-gradient-to-br from-blue-50 to-indigo-100 p-8 flex flex-col items-center justify-center text-center shadow-lg hover:shadow-2xl transition-all duration-300">
            <h3 className="text-2xl font-bold text-gray-800">{t('home.gallery.viewMore')}</h3>
            <p className="text-gray-600 mt-2 mb-6">{t('home.gallery.viewMoreDesc')}</p>
            <Link
              to="/albums"
              className="inline-flex items-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 transform hover:-translate-y-1 transition-all duration-300 shadow-lg"
            >
              {t('home.gallery.exploreGallery')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryPreviewSection; 